import React from 'react';
import { AutocompleteRenderOptionState } from '@material-ui/lab/Autocomplete';
import { AutocompleteOptionModel } from '../../tools/Autocomplete.model';
import { getSubstringBefore, getSubstringAfter } from '../../../../utils/stringUtils';
import { getMatch } from '../../tools/Autocomplete.utils';

interface AutocompleteRenderOptionProps {
  option: AutocompleteOptionModel;
  state: AutocompleteRenderOptionState;
  hasUserChangedOption: boolean;
  debouncedInputValue: string;
  getOptionLabel: (option: AutocompleteOptionModel) => string;
  filterTextClassName: string;
  renderOption?: (
    option: AutocompleteOptionModel,
    state: AutocompleteRenderOptionState,
    hasUserChangedOption: boolean,
    getMatch: (label: string, substringBefore: string, substringAfter: string) => string
  ) => React.ReactNode;
}

export const AutocompleteRenderOption: React.FC<AutocompleteRenderOptionProps> = ({
  option,
  state,
  hasUserChangedOption,
  debouncedInputValue,
  getOptionLabel,
  filterTextClassName,
  renderOption,
}) => {
  if (renderOption) {
    return <>{renderOption(option, state, hasUserChangedOption, getMatch)}</>;
  }

  const label = getOptionLabel(option);

  if (!debouncedInputValue || hasUserChangedOption) {
    return <>{label}</>;
  }

  const substringBefore = getSubstringBefore(label, debouncedInputValue);
  const substringAfter = getSubstringAfter(label, debouncedInputValue);
  const match = getMatch(label, substringBefore, substringAfter);

  return (
    <div>
      {substringBefore}
      <span className={filterTextClassName}>{match}</span>
      {substringAfter}
    </div>
  );
};

